import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgIf } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { OwnerOverviewComponent } from '../owner-overview/owner-overview.component';
import { BreadcrumbComponent } from '../../../elements/breadcrumb/breadcrumb.component';
import { HttpServiceService } from '../../../services/http-service.service';
import { NgxToastrService } from '../../../_services/ngx-toastr/ngx-toastr.service';
import { LoadingService } from '../../../services/loading.service';
import { LocalStorageService } from '../../../services/local-storage.service';
import { USER_PERMISSIONS } from '../../../app.constants';

@Component({
  selector: 'app-owner-additional-info',
  imports: [OwnerOverviewComponent, FormsModule, NgIf, BreadcrumbComponent],
  templateUrl: './owner-additional-info.component.html',
  styleUrl: './owner-additional-info.component.css'
})
export class OwnerAdditionalInfoComponent {
  breadcrumbList : any;
  userId : string = '';
  additionalInfo : string = '';
  savedAdditionalInfo : string = '';
  loadingService = inject(LoadingService);
  private authService = inject(LocalStorageService);
  private routeSubscription?: Subscription;
  private updateAdditionalInfoSubscription?: Subscription;

  constructor(private httpService : HttpServiceService, private route: ActivatedRoute, private alertService: NgxToastrService, private router: Router){
    this.routeSubscription = this.route.paramMap.subscribe(params => {
      this.userId = params.get('id') ?? "";
      let userType = params.get('type') ?? "";
      this.breadcrumbList = {
        breadcrumb_path: userType == "owner" ? "Owners" : "Tenants",
        currentURL: 'Additional Info',
        breadcrumb_url : '/admin/'+ (userType == "owner" ? "owners" : "tenants")
      }
    });
  }

  goBackToList(event : any){
    this.router.navigate([this.breadcrumbList.breadcrumb_url]);
  }

  getUserDetails(data : any){
    this.additionalInfo = data?.additional_info ?? '';
    this.savedAdditionalInfo = this.additionalInfo;
  }

  get hasChanges(){
    return this.additionalInfo !== this.savedAdditionalInfo;
  }

  onSave(){
    if(!this.hasChanges || this.loadingService.isLoading()) return;
    const value = this.additionalInfo;
    this.updateAdditionalInfoSubscription = this.httpService.editUser({ additional_info: value }, this.userId).subscribe({
      next : (response) => {
        this.savedAdditionalInfo = value;
        this.alertService.success(response.message, "toast-top-right");
      }
    });
  }

  ngOnDestroy(){
    this.updateAdditionalInfoSubscription?.unsubscribe();
    this.routeSubscription?.unsubscribe();
  }

  get checkUserAdditionalInfoEdit() {
    return this.authService.checkPermission(USER_PERMISSIONS.USER_INFO.USER_PERSONAL_UPDATE);
  }
}
